<template>
    <div>
        <CCol sm="12">
            <CCard>
                <CCardBody class="d-flex flex-column">
                    <h2 class="col-lg-12 text-center mb-3">{{ $t('settings') }}</h2>            
                    <!-- Backoffice settings -->
                    <CCol>
                        <CRow>
                            <label class="font-weight-bold">{{ $t('backoffice') }}</label>
                        </CRow>
                    </CCol>
                    <!-- Language selector -->
                    <CRow id="language-selector">
                        <CCol class="pl-0">
                            <label class="">{{ $t('language') }}</label>
                        </CCol>
                        <CCol class="d-flex justify-content-end pr-0">
                            <CButton class="mr-2" v-for="language in supportedLanguages" :key="language.key" color="primary" variant="outline" :pressed="locale == language.key" square size="sm" @click="onLanguageClicked(language)">
                                {{language.label}}
                            </CButton>
                        </CCol>
                    </CRow>
                    <!-- Action button -->
                    <CCol class="d-flex justify-content-end mt-3">
                        <CRow sm="2" class="align-self-end">
                            <CSpinner v-if="loading" variant="success" small></CSpinner>
                            <CButton v-else type="button" class="btn btn-primary" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                        </CRow>
                    </CCol>
                </CCardBody>
            </CCard>
        </CCol>
        <ConfirmationPopUp @closeConfirmRequested="onClickConfirmationPopup" v-model="showConfirmationPopup"></ConfirmationPopUp>
    </div>
</template>
 
<script>
import i18n from '@/helpers/i18n';
import { CONSTANTS } from '@/helpers/consts';
import ConfirmationPopUp from "@/views/controls/popups/ConfirmationPopUp.vue";


 export default {
    components: {ConfirmationPopUp },
    data () {
        return {
            submitted: false,
            locale: i18n.locale,
            supportedLanguages: CONSTANTS.supportedLanguages,
            currentLanguage: CONSTANTS.supportedLanguages[0],
            updateError: '',
            loading: false,
            errorAlert:"",
            showErrorMessages: false,
            showConfirmationPopup: false,
        }
    },
   
    methods:{
        languageChanged(language){
            this.currentLanguage = language;
        },
       
        onLanguageClicked (language) {
            this.locale = language.key;
        },
        
        submitClicked()
        {
            this.submitted = true;
            this.loading = true;
            this.updateLocale();
            this.showConfirmationPopup = true;   
            
        },
        updateLocale()
        {
            if(this.$i18n.locale != this.locale)
            {
                this.$i18n.locale = this.locale;
                localStorage.setItem('locale', this.$i18n.locale);
            }
        },
        onClickConfirmationPopup(value){
            this.showConfirmationPopup = value; 
            this.$router.go(); // Refresh   
        },
    },
    watch:
    {   errorAlert: function(val)
    {
        if(val != "")
        {
            alert("One or more errors ocured! \n"+val);
        }
        },
        processTask: function(val)
        {
            if(val)
            {
                this.showConfirmationPopup = true;
            }

            this.loading = false;
        },
        type: function()
        {
            this.updateError = this.type == "alert-danger" ? this.message : '';
            this.loading = false;
        },
        message: function()
        {
            this.updateError = this.type == "alert-danger" ? this.message : '';
            this.loading = false; 
            this.showErrorMessages = true;
            this.errorAlert = this.message;     
        },
      
    }
}
 
</script>

<style>
#language-selector
{
    margin: 25px 0;
}

input[type="color"]
{
    width: 50px;
    height: 50px;
    padding: 0;
    border: none;
    cursor: pointer;
}

.base-image-input {
  display: block;
  width: 200px;
  height: 200px;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}

.placeholder {
  background: #F0F0F0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
  font-family: Helvetica, Arial, Verdana, Tahoma, sans-serif;
}

.placeholder:hover {
  background: #E0E0E0;
}

.file-input {
  display: none;
}

.input-group-append
{
  height: fit-content;
}

img
{
  width: 50%;
  height: 50%;
}

</style>